import { render, staticRenderFns } from "./articleComment.vue?vue&type=template&id=02a4b842&scoped=true"
import script from "./articleComment.vue?vue&type=script&lang=js"
export * from "./articleComment.vue?vue&type=script&lang=js"
import style0 from "./articleComment.vue?vue&type=style&index=0&id=02a4b842&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02a4b842",
  null
  
)

export default component.exports